import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';
import { SignalsTableMarkdownItem } from './signals-table-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown: `:::signals-table` */
export const SIGNALS_TABLE_DIRECTIVE = 'signals-table';

/**
 * Remark plugin definition for the `signals-table` container directive.
 *
 * The directive body must be a JSON array of signal descriptors; the raw JSON string is passed to
 * {@link SignalsTableMarkdownItem} via the `jsonData` prop.
 *
 * Usage in markdown:
 * ```
 * :::signals-table
 * [{"signalName":"CLK","direction":"input","digital":true}]
 * :::
 * ```
 */
export const signalsTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(SIGNALS_TABLE_DIRECTIVE),
	item: SignalsTableMarkdownItem,
};
